import styled from "styled-components";
import PropTypes from "prop-types";

import { colors } from "./colors";

const FormFieldErrorBorder = styled.div`
    position: absolute;
    bottom: 0;
    left: ${({ forStripeElement }) => (forStripeElement ? "0" : "-3px")};
    width: ${({ forStripeElement }) =>
        forStripeElement ? "100%" : "calc(100% + 6px)"};
    height: 3px;
    background-color: ${({ invalid }) =>
        invalid ? colors.coral : "transparent"};
`;

FormFieldErrorBorder.propTypes = {
    invalid: PropTypes.bool,
    forStripeElement: PropTypes.bool
};

export { FormFieldErrorBorder };
